// extracted by mini-css-extract-plugin
export default {"gallery_image":"GalleryBox_gallery_image__FdYEx","light_box":"GalleryBox_light_box__vWvBm"};